import React from "react";
import { Button } from "react-bootstrap";
import IconSvg from "../../SharedComponents/IconSvg";

export default function DownloadButtonUi({ StartPdfExportProcess, uiType }) {
  if (uiType === "assignedAssessmentPdfButton") {
    return (
      <Button
        onClick={StartPdfExportProcess}
        className={"button secondary p-0"}
        style={{ height: 35, width: 35, borderRadius: "10px", borderColor: "#8B8C89" }}
      >
        <IconSvg icon={"pdf"} fill={"#8B8C89"}></IconSvg>
      </Button>
    );
  } else {
    return (
      <Button className="_pdf-download-button" onClick={StartPdfExportProcess}>
        Pdf
        <span style={{ paddingLeft: "5px" }}>
          <IconSvg icon="download" />
        </span>
      </Button>
    );
  }
}
